/*
 * Copyright 2026 Sony Corporation
 */

import { useSyncExternalStore } from 'react';

import { disconnect, readSession, subscribe, type SketchfabSession } from '../services/sketchfab-auth';

export interface UseSketchfabAuthResult {
  session: SketchfabSession | null;
  disconnect: () => void;
}

export const useSketchfabAuth = (): UseSketchfabAuthResult => ({
  session: useSyncExternalStore(subscribe, readSession),
  disconnect,
});
